<template>
<validation-observer ref="settingsForm" tag="form" @submit.prevent="onSubmit">
    <b-form>
    <b-row>
        <b-col cols="12">
            <b-form-group
                class="row"
                label="Shipping price"
                label-for="h-shipping-price"
                label-cols-md="2"
                content-cols-lg="4"
            >
                <validation-provider
                #default="{ errors }"
                rules="required"
                name="Shipping price"
                vid="shippingPrice"
                >
                <b-form-input
                    v-model="shippingPrice"
                    id="h-shipping-price"
                    :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
            </b-form-group>

       </b-col>
    </b-row>
    </b-form>
</validation-observer>
</template>

<script>
import {
BRow,
BCol,
BFormGroup,
BFormInput,
BForm
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Toast from '@/components/Toast.vue'

export default {
components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    ValidationProvider,
    ValidationObserver,
},
props: {
    action: { type: String, default: null },
    entity: { type: String, default: null },
},
data() {
    return {
    apiUrl: this.$store.state.apiUrl,
    shippingPrice: 0
    }
},
watch: {
    action(newVal) {
    if (newVal === 'add') {
        this.onSubmit()
    }
    if (newVal === 'update') {
        this.onSubmit()
    }
    },
},
created() {
    this.$Settings.getResource({ id: 1 }).then(response => {
        this.shippingPrice = response.data.shippingPrice
    })
},
methods: {
    async onSubmit() {
        const isValid = await this.$refs.settingsForm.validate()
        if (isValid) {
            if (this.action === 'update') {
                this.$Settings
                .updateResource({ id: 1, body: { shippingPrice: this.shippingPrice } })
                .then(response => {
                if (response.status === 200) {
                    this.$helper.showToast(
                    this.$toast,
                    Toast,
                    `${this.entity} updated`,
                    '',
                    'success',
                    )
                }
                })
                .catch(error => {
                if (error.response) {
                    this.$emit('clearAction')
                    this.$helper.showToast(
                    this.$toast,
                    Toast,
                    `Failed to update ${this.entity.toLowerCase()}`,
                    error.response.data['hydra:description'],
                    'danger',
                    )
                }
                })
                this.$emit('clearAction')
            }
        } else {
            this.$emit('clearAction')
        }
    },
},
}
</script>
